import * as React from 'react'

export default function EquipmentViewWrapper({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <div className={`equipment ${className}`}>{children}</div>
}
